export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11661.b5b87863.jpg";